import { experimentalStyled } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
var DayCellStyles = {
  minHeight: '77px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column'
};
var DayCell = experimentalStyled(Box)(DayCellStyles);
export { DayCell };